import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import { getNotFromSimpleFilter } from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const operatorMap: Record<string, string> = {
  '<': 'is before',
  '>': 'is after',
  '=': 'is',
};

const operatorMapInverse = invertMap(operatorMap);

const notMap: Record<string, string> = {
  'is before': 'is not before',
  'is after': 'is not after',
  is: 'is not',
};

const notMapInverse = invertMap(notMap);

/**
 * Converts a date string (YYYY-MM-DD) to RFC3339 UTC timestamp
 */
function toRFC3339(dateStr: string): string {
  return `${dateStr}T00:00:00Z`;
}

/**
 * Extracts YYYY-MM-DD from an RFC3339 timestamp
 */
function fromRFC3339(rfc3339: string): string {
  return rfc3339.substring(0, 10);
}

export const RiskLastSeen: SimpleFilterDefinition = {
  apiField: 'visited',
  uiField: 'Last Seen',
  inputType: 'date',
  operators: [
    'is before',
    'is not before',
    'is after',
    'is not after',
    'is',
    'is not',
  ],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    let operator = operatorMap[queryFilter.operator] || queryFilter.operator;
    if (queryFilter.not === true && notMap[operator]) {
      operator = notMap[operator];
    }

    return {
      field: 'Last Seen',
      operator,
      value: fromRFC3339(queryFilter.value as string),
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    let operator = simpleFilter.operator;
    const isNot = !!notMapInverse[operator];
    if (isNot) {
      operator = notMapInverse[operator];
    }

    return {
      field: 'visited',
      operator: (operatorMapInverse[operator] ||
        operator) as QueryFilter['operator'],
      value: toRFC3339(simpleFilter.value as string),
      not: getNotFromSimpleFilter(simpleFilter, notMapInverse),
    };
  },
};
